import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Packages } from 'src/app/shared/models/packages.model';
import * as moment from 'moment';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { Router } from '@angular/router';
import { PackagesService } from '../packages.service';

@Component({
  selector: 'app-packages-log',
  templateUrl: './packages-log.component.html',
  styleUrls: ['./packages-log.component.css']
})
export class PackagesLogComponent implements OnInit {
  viewFlag = false;
  viewAdminApprovalFlag = false;
  // packageTypes = [];
  @ViewChild('viewPkg', { static: true }) viewPkg: ElementRef;

  package = new Packages();
  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {
      // if (this.currentFilterObject.packageType) {
      //   return this.currentFilterObject.packageType.includes(
      //     row.packageType
      //   );
      // }
      return true;
    })
      .filter(row => {
        if (
          this.currentFilterObject.startDate &&
          this.currentFilterObject.startDate.startDate &&
          this.currentFilterObject.startDate.endDate
        ) {
          return moment(row.startDate).isBetween(
            // @ts-ignore
            this.currentFilterObject.startDate.startDate._i,
            // @ts-ignore
            this.currentFilterObject.startDate.endDate._i
          );
        } else {
          return true;
        }
      })
      .filter(row => {
        if (this.currentFilterObject.price) {
          if (row.price.includes(':')) {
            let from = +row.price.split(':')[0];
            let to = +row.price.split(':')[1];

            return (+this.currentFilterObject.price >= from && +this.currentFilterObject.price <= to)
          }
          else {
            return +this.currentFilterObject.price == +row.price;
          }
        }
        return true;
      })
    // .filter(row => {
    //   if (this.currentFilterObject.rating) {
    //     return row.rating.includes(this.currentFilterObject.rating);
    //   }
    //   return true;
    // });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }
  private Data = [] as Array<TableViewItem>;

  tableColumns = [
    'packageName',
    'packageType',
    'startDate',
    'price',
    // 'rating'
  ];

  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'startDate',
      fieldDisplayName: 'Start Date ',
      fieldType: 'daterange'
    },
    // {
    //   fieldName: 'packageType',
    //   fieldDisplayName: 'Package Type ',
    //   fieldType: 'select',
    //   multiple: true,
    //   hasSelectAll: false,
    //   defaultValue: null,
    //   options: [
    //   ]
    // },
    {
      fieldName: 'price',
      fieldDisplayName: 'Price ',
      fieldType: 'text'
    },
    // {
    //   fieldName: 'rating',
    //   fieldDisplayName: 'Rating ',
    //   fieldType: 'select',
    //   multiple: false,
    //   hasSelectAll: false,
    //   defaultValue: null,
    //   options: []
    // }
  ];

  constructor(private packageApi: PackagesService, private router: Router) { }

  currentFilterObject = {} as FilterModel;
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'viewPackage',
      class: 'btn',
      iconClasses: 'fa fa-eye',
      onClick: this.updateViewFlag()
    },
    {
      type: 'icon',
      slug: 'editPackage',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    },
    {
      type: 'icon',
      slug: 'addImageAlt',
      class: 'btn',
      iconClasses: 'fa fa-plus'
    }
  ];

  ngOnInit() {
    // this.sharedService.getLanguages().then(response => {
    //   this.reportFilter[1].options = response.data.languages.map(l => ({value: l.id, display: l.name}))
    // })

    this.fetchAllPackages();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllPackages() {
    this.packageApi.getAllPackages().subscribe(response => {
      this.data = response.data.experiences.map(r => {
        // this.packageTypes = r.packageTypes;
        // this.reportFilter[1].options = r.packageTypes.map(l => ({
        //   value: l.id,
        //   display: l.name
        // }));
        // this.reportFilter[1].options.push(
        //   { value: 'WEEKLY', display: 'WEEKLY' },
        //   { value: 'SEASONAL', display: 'SEASONAL' },
        //   { value: 'WEEKLY SEASONAL', display: 'WEEKLY/SEASONAL' },
        //   { value: null, display: 'All' }
        // );
        this.package = r;
        if (r.city == null) {
          r.city = '-';
          r.country = '-';
        }
        // let rate = '';
        // if (r.rating == null) {
        //   rate = '-';
        // } else {
        //   rate = r.rating;
        // }
        let expType = '';
        let expID = '';
        // if (r.packageTypes == null) {
        //   expType = '-';
        //   expID = '-';
        // } else {
        //   if (r.packageTypes.length === 1) {
        //     expType = r.packageTypes[0].name;
        //     expID = r.packageTypes[0].id;
        //   } else {
        //     expType =
        //       r.packageTypes[0].name + ' ' + r.packageTypes[1].name;
        //     expID = r.packageTypes[0].id + '' + r.packageTypes[1].id;
        //   }
        // }
        let localname = '';
        if (r.Local == null) {
          localname = '-';
        } else {
          localname = r.Local.firstName + ' ' + r.Local.lastName;
        }

        let price: string = '';
        let priceMax = '';
        let priceMin = '';
        if (r.Price.length === 1) price = r.Price[0].amount;
        else {
          priceMax = Math.max.apply(Math, r.Price.map(a => a.amount));
          priceMin = Math.min.apply(Math, r.Price.map(a => a.amount));
          price = priceMin + ' : ' + priceMax
        }


        return {
          id: r.id,
          packageName: r.name,
          // expTypeID: expID,
          // packageType: expType,
          localName: localname,
          startDate: moment(r.startDate).format('YYYY-MM-DD HH:mm'), //r.startDate,
          price: String(price),
        } as TableViewItem;
      });
    });
  }
  updateViewFlag () {
    this.viewFlag = true;
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'viewPackage':
        this.viewPkg.nativeElement.click();
        this.viewFlag = true;
        this.package = event.on;
        break;
      case 'editPackage':
        this.editPackage(event.on.id);
        break;
      case 'addImageAlt':
        this.addImageAlt(event.on.id);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  editPackage(id) {
    this.router.navigate(['/packages/edit/' + id]);
  }
  addImageAlt(id) {
    this.router.navigate(['/packages/image-alt/' + id]);
  }
}

interface TableViewItem {
  id: number;
  packageName?: string;
  // packageType?: string;
  // expTypeId?: any;
  startDate?: string;
  price?: string;
  // rating?: string;
  isOnline?: boolean;
}
interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
interface FilterModel {
  packageType: string;
  startDate: DateRangeModel;
  price: string;
  // rating: string;
}
